import $ from "jquery";
import Form from "./forms/form";
import Tracker from "./common/tracker";
import Amp from "./amp/amp";
import Phone from "./amp/phone";
import * as Listings from "./listings";
import Lightbox2 from "./lightbox2";

/**
 * Ion (v1.1.1): index.js
 */
(($) => {
  if (typeof $ === "undefined") {
    throw new TypeError(
      "Ion JavaScript requires jQuery. jQuery must be included before Ion JavaScript."
    );
  }
})($);

export { Form, Tracker, Amp, Phone, Listings, Lightbox2 };
